import { render } from "./ProvisionedIcon.vue?vue&type=template&id=3b21e56a"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/atoms/icons/ProvisionedIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b21e56a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b21e56a', __exports__)) {
    api.reload('3b21e56a', __exports__)
  }
  
  module.hot.accept("./ProvisionedIcon.vue?vue&type=template&id=3b21e56a", () => {
    api.rerender('3b21e56a', render)
  })

}


export default __exports__